













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import print from "@/utils/print";
import { Carousel } from "@/types/api/system";
import config from "@/config/default";
import { saveCarouselItem, updateCarouselItem } from "@/api/system";
import copy from "@/utils/deepCopy";

@Component
export default class Dialog extends Vue {
  @Prop() dialogVisible!: boolean;
  @Prop() item!: Carousel;
  @Prop() type!: string;

  // 构造器自有属性
  options: any = [
    { id: 1, name: "产品" },
    { id: 2, name: "页面" },
  ];
  ruleFormName: string = "ruleForm";
  // 规则
  rules: any = {
    title: [
      { required: true, message: "请输入轮播图标题", trigger: "blur" },
      {
        min: 1,
        max: 20,
        message: "长度在 1 到 10 个字符",
        trigger: "blur",
      },
    ],
    img: [{ required: true, message: "请上传图片", trigger: "change" }],
    linkType: [{ required: false, message: "请选择类型", trigger: "change" }],
    linkContent: [
      { required: false, message: "请输入关联内容", trigger: "blur" },
    ],
  };
  form: Carousel = {
    img: "",
    linkContent: "",
    linkType: "",
    subtitle: "",
    title: "",
    type: 0,
    id: 0,
  };

  @Watch("item")
  modifyItem() {
    this.form = copy(this.item);
    this.form.linkType = this.form.linkType == 0 ? "" : this.form.linkType;
  }
  /**
   * methods
   */
  // 上传成功
  onSuccess(res: any, file: any) {
    this.form.img = this.$uploadImgUrl + "/" + res.data.url;
  }
  // 关闭对话框
  close() {
    this.$emit("close", false);
    let ref: any = this.$refs;
    ref[this.ruleFormName].resetFields();
  }
  // 确认提交
  confirm() {
    let ref: any = this.$refs;
    ref[this.ruleFormName].validate(async (valid: any) => {
      // 校验成功
      if (valid) {
        let prom: any;
        if (this.type == "add") {
          prom = await saveCarouselItem(this.form); // 添加
        } else {
          prom = await updateCarouselItem(this.form); // 修改
        }
        // 成功
        if (prom.code == 200) {
          this.$message.success("提交成功");
          this.close();
          this.$emit("getData");
        }
      } else {
        return false;
      }
    });
  }
  // 图片上传之前限制
  beforeAvatarUpload(file: any) {
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      this.$message.error("上传头像图片大小不能超过 1MB!");
    }
    return isLt1M;
  }
}
